export default __webpack_public_path__ + "media/application/assets/images/signing-instructions/NE-75ef5dcc67ad63eb6279c5ef0499f74d.PNG";